/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const CLEAR_STATEMENT = 'app/Payoff/CLEAR_STATEMENT';

export const CREATE_PAYOFF_STATEMENT = 'app/Payoff/CREATE_PAYOFF_STATEMENT';
export const CREATE_PAYOFF_STATEMENT_FAILURE = 'app/Payoff/CREATE_PAYOFF_STATEMENT_FAILURE';
export const CREATE_PAYOFF_STATEMENT_SUCCESS = 'app/Payoff/CREATE_PAYOFF_STATEMENT_SUCCESS';

export const FETCH_PAYOFF_DATES = 'app/Payoff/FETCH_PAYOFF_DATES';
export const FETCH_PAYOFF_DATES_FAILURE = 'app/Payoff/FETCH_PAYOFF_DATES_FAILURE';
export const FETCH_PAYOFF_DATES_SUCCESS = 'app/Payoff/FETCH_PAYOFF_DATES_SUCCESS';

export const FETCH_PAYOFF_DOCUMENT = 'app/Payoff/FETCH_PAYOFF_DOCUMENT';
export const FETCH_PAYOFF_DOCUMENT_FAILURE = 'app/Payoff/FETCH_PAYOFF_DOCUMENT_FAILURE';
export const FETCH_PAYOFF_DOCUMENT_SUCCESS = 'app/Payoff/FETCH_PAYOFF_DOCUMENT_SUCCESS';

export const FETCH_PAYOFF_STATEMENT = 'app/Payoff/FETCH_PAYOFF_STATEMENT';
export const FETCH_PAYOFF_STATEMENT_FAILURE = 'app/Payoff/FETCH_PAYOFF_STATEMENT_FAILURE';
export const FETCH_PAYOFF_STATEMENT_SUCCESS = 'app/Payoff/FETCH_PAYOFF_STATEMENT_SUCCESS';

export const CHANGE_PAYOFF_STEP = 'app/Payoff/CHANGE_PAYOFF_STEP';

export const UPDATE_REQUEST_TYPE = 'app/Payoff/UPDATE_REQUEST_TYPE';
export const UPDATE_SELECTED_DATE = 'app/Payoff/UPDATE_SELECTED_DATE';
export const UPDATE_SELECTED_PAYOFF_REASON = 'app/Payoff/UPDATE_SELECTED_PAYOFF_REASON';

export const FETCH_PAYOFF_HISTORY = 'app/Payoff/FETCH_PAYOFF_HISTORY';
export const FETCH_PAYOFF_HISTORY_FAILURE = 'app/Payoff/FETCH_PAYOFF_HISTORY_FAILURE';
export const FETCH_PAYOFF_HISTORY_SUCCESS = 'app/Payoff/FETCH_PAYOFF_HISTORY_SUCCESS';

export const RESET_BANNER_ERROR = 'app/Payoff/RESET_BANNER_ERROR';
export const RESET_STATE = 'app/Payoff/RESET_STATE';

export const SET_FILE = 'app/Payoff/SET_FILE';

export const TOGGLE_DRAWER = 'app/Payoff/TOGGLE_DRAWER';

export const FETCH_ERROR_MESSAGE = 'We are unable to fetch your statement history.\nPlease try again later or call customer service.';
export const FETCH_STATEMENT_ERROR_MESSAGE = 'We are unable to fetch your statement status at the moment. Please try again later or call customer service for assistance.';
export const POPUP_ERROR_MESSAGE = 'We are unable to display your statement.\nPlease unblock pop-ups from this webpage in your browser settings.';

// FetchDates partial errors
export const IS_INELIGIBLE = 'isIneligible';
export const PAYOFF_DATES_BANNER_ERROR = 'We were unable to fetch the dates for your payoff request.\nPlease try again later or call customer service.';

// Mancode Y error
export const IS_MANCODE_Y = 'isLoanMancodeY';

export const PAYOFF_DICTIONARY = {
  dates: {
    default: {
      text: INTL_IDS.STATEMENTS_DATES_DEFAULT_TEXT,
      title: INTL_IDS.STATEMENTS_DATES_DEFAULT_TITLE,
    },
    [IS_INELIGIBLE]: {
      text: INTL_IDS.STATEMENTS_DATES_ISINELIGIBLE_TEXT,
      title: INTL_IDS.STATEMENTS_DATES_ISINELIGIBLE_TITLE,
    },
    [IS_MANCODE_Y]: {
      text: INTL_IDS.STATEMENTS_DATES_ISMANCODEY_TEXT,
      title: INTL_IDS.STATEMENTS_DATES_ISMANCODEY_TITLE,
    },
    paydown: {
      text: INTL_IDS.STATEMENTS_DATES_PAYDOWN_TEXT,
      title: INTL_IDS.STATEMENTS_DATES_PAYDOWN_TITLE,
    },
    payoff: {
      text: INTL_IDS.STATEMENTS_DATES_PAYOFF_TEXT,
      title: INTL_IDS.STATEMENTS_DATES_PAYOFF_TITLE,
    },
  },
  retrieving: {
    default: {
      text: 'This may take up to 5 minutes. Please do not refresh the page. Thank you for your patience.',
      title: 'We are retrieving your statement',
    },
  },
  view: {
    default: {
      text: INTL_IDS.STATEMENTS_VIEW_DEFAULT_TEXT,
      title: INTL_IDS.STATEMENTS_VIEW_DEFAULT_TITLE,
    },
  },
};

export const PAYOFF_HISTORY = {
  paydownTitle: INTL_IDS.STATEMENTS_HISTORY_PAYDOWNTITLE,
  text: INTL_IDS.STATEMENTS_HISTORY_TEXT,
  title: INTL_IDS.STATEMENTS_HISTORY_TITLE,
};

export const PAYOFF_EMPTY_SET = {
  text: INTL_IDS.STATEMENTS_EMPTYSET_TEXT,
  title: INTL_IDS.STATEMENTS_EMPTYSET_TITLE,
};

export const FETCH_PAYOFF_ERROR = { body: 'We are unable to fetch your statement status at the moment. Please try again later or call customer service for assistance.' };

export const NEED_SPECIALIST_ERROR = {
  body: INTL_IDS.STATEMENTS_NEEDSPECIALIST_BODY,
  title: INTL_IDS.STATEMENTS_NEEDSPECIALIST_TITLE,
};

export const PAYOFF_REASON_CODE_DICTIONARY = {
  '12000.1000': 'Payoff request date is invalid.',
  12001.1013: 'Ineligible to request a payoff statement.',
  12001.1014: 'Payoff reason is invalid.',
  12099: 'We were unable to process your request. Please try again later or call customer service for assistance',
  12099.2001: 'We will send you an email when the service is available.',
};

export const PAYDOWN_MESSAGE = 'Calculation valid for funds received today.';

export const PAYOFF_PAYDOWN_STEP_DICTIONARY = {
  0: {
    disableSubmitButton: true,
    showCancel: false,
    showDatePicker: false,
    showNextButton: false,
    showPaydown: true,
    showPayoff: true,
    showSubmitButton: false,
  },
  1: {
    disableSubmitButton: true,
    showCancel: false,
    showDatePicker: false,
    showNextButton: true,
    showPaydown: true,
    showPayoff: true,
    showSubmitButton: false,
  },
  2: {
    disableSubmitButton: true,
    showCancel: true,
    showDatePicker: true,
    showNextButton: false,
    showPaydown: false,
    showPayoff: false,
    showSubmitButton: true,
  },
  3: {
    disableSubmitButton: false,
    showCancel: false,
    showDatePicker: false,
    showNextButton: false,
    showPaydown: true,
    showPayoff: true,
    showSubmitButton: true,
  },
};

export const MANCODE_Y_TEXT = '<b>Ineligible to request a payoff statement.</b>\nFor additional information, please call customer service at <a>1-877-330-4051</a>.';
